<template>
  <div class="Dialog error" v-if="state.matches('task.checkZonesRole.platformNotMatch')">
    <div class="inner">
      <div class="pic-bg"></div>
      <div class="pic-birld"></div>
      <div class="pic-cloud"></div>

      <div class="title"><span>温馨提示</span></div>

      <div class="inner-body">
        <p class="content">
           您的账号已在其他分区参与活动</p>


      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ErrorPage",
  props: ["state", "send"]
}
</script>

<style scoped>
</style>
